import React, { useContext } from "react";

import { INDUSTRY_TYPE_ORDER } from "../constants/Samples";
import { ImageOacJson, InferenceConfig } from "../types/demo";

export interface ImageFile {
  new (
    fileBits: BlobPart[],
    fileName: string,
    options?: FilePropertyBag | undefined,
  ): globalThis.File;
  prototype: globalThis.File;
}
export type ResultFileId = string; // uuidv4();
export type IndustryType = (typeof INDUSTRY_TYPE_ORDER)[number];
export interface DocumentInfo {
  modelName: string;
  source?: string;
  industryType: IndustryType;
  docType: string;
}
export interface ResultFile {
  id: ResultFileId;
  title: string;
  result: ImageOacJson;
  modelIndex: number;
  documentInfo?: DocumentInfo;
  inferenceConfig?: InferenceConfig;
  originFile?: File;
}
export interface Model {
  name: string;
  serviceName: string | undefined;
  type: string;
  url: string;
  status: string | undefined;
}
export type InferenceType = "new" | "update" | null;
export interface InferenceState {
  isInfering: boolean;
  inferenceType: InferenceType;
}
export const INFERENCE_STATE = {
  IDLE: {
    isInfering: false,
    inferenceType: null,
  },
  NEW: {
    isInfering: true,
    inferenceType: "new",
  },
  UPDATE: {
    isInfering: true,
    inferenceType: "update",
  },
} as const;

export interface ValidatorFiles {
  files: ResultFile[];
  selectedFileIndex: number;
  inferenceState: InferenceState;
  setSelectedFileIndex: (selected: number) => void;
  setFiles: (selected: ResultFile[]) => void;
  setInferenceState: (inferenceState: InferenceState) => void;
}

export interface ValidatorModels {
  models: Model[];
  selectedModelIndex: number;
  setSelectedModelIndex: (selected: number) => void;
}

export const emtpyFiles: ResultFile[] = [];
export const emtpyModels: Model[] = [];

export const ValidatorFileContext = React.createContext<ValidatorFiles>({
  selectedFileIndex: -1,
  files: emtpyFiles,
  inferenceState: INFERENCE_STATE.IDLE,
  setSelectedFileIndex: () => {},
  setFiles: () => {},
  setInferenceState: () => {},
});

export const ValidatorFileProvider = ValidatorFileContext.Provider;

export function useValidatorResult(): ValidatorFiles {
  return useContext(ValidatorFileContext);
}

export const ValidatorModelsContext = React.createContext<ValidatorModels>({
  models: emtpyModels,
  selectedModelIndex: 0,
  setSelectedModelIndex: () => {},
});

export const ValidatorModelsProvider = ValidatorModelsContext.Provider;

export function useValidatorModelsResult(): ValidatorModels {
  return useContext(ValidatorModelsContext);
}
